import { render, staticRenderFns } from "./CurrencyValue.vue?vue&type=template&id=1f93f3b1&"
import script from "./CurrencyValue.vue?vue&type=script&lang=ts&"
export * from "./CurrencyValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports